/**
 * Profile phone number localization fallback strings.
 *
 * These keys must be added to the remote L10N management system to appear in production.
 * This file provides fallback values so the profile phone field works before L10N keys are provisioned.
 *
 * Keys to add to L10N system:
 *   editUserAccount.phones           = "ВАШ ТЕЛЕФОН"
 *   editUserAccount_phones.placeholder = "Введите номер телефона"
 */

import I18n from 'i18n-js';

const PROFILE_PHONE_STRINGS = {
    ru: {
        editUserAccount: {
            phones: 'ВАШ ТЕЛЕФОН',
        },
        editUserAccount_phones: {
            placeholder: 'Введите номер телефона',
        },
    },
    en: {
        editUserAccount: {
            phones: 'YOUR PHONE',
        },
        editUserAccount_phones: {
            placeholder: 'Enter phone number',
        },
    },
};

const mergeDeep = (target, source) => {
    const result = { ...target };
    Object.keys(source).forEach((key) => {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            result[key] = mergeDeep(result[key] || {}, source[key]);
        } else if (!(key in (result || {}))) {
            result[key] = source[key];
        }
    });
    return result;
};

/**
 * Injects profile phone localization fallback strings into the active i18n locale and registers
 * the phones field in the editUserAccount form schema.
 * Only fills in keys that are not yet present (does not override existing L10N values).
 * Call this after setLocale() and applyEmailLoginFallbackStrings() during app initialization.
 */
export const applyProfilePhoneFallbackStrings = (addFormFieldFn) => {
    const locale = I18n.locale || 'ru';
    const fallback = PROFILE_PHONE_STRINGS[locale] || PROFILE_PHONE_STRINGS.ru;

    const existing = I18n.translations[locale] || {};
    I18n.translations[locale] = mergeDeep(existing, fallback);

    if (addFormFieldFn) {
        addFormFieldFn('editUserAccount', {
            id: 'phones',
            type: 'phone',
            required: true,
        }, 0);
    }
};
